import UIUtils from 'js/lib/UIUtils';
import { CONNECTION_CATEGORY_REST } from 'js/constants/connectionCategories';
import createFlowService from 'new/components/flows/service/createFlowService';

const flowService = createFlowService();

type GetInitialSinkConfig = (a: {
  sinkConfig: any;
  dataSchema: any;
  isEditMode?: boolean;
  connectionCategory?: string;
}) => {
  sinkMapping?: any;
  sinkConfig: any;
};

export default function createRestAPIDestinationService() {
  const getInitialSinkConfig: GetInitialSinkConfig = (props) => {
    let {
      sinkConfig,
      dataSchema,
      isEditMode = false,
      connectionCategory = CONNECTION_CATEGORY_REST,
    } = props;

    if (dataSchema) {
      const sinkMapping = UIUtils.getSinkMappingFromAttributes(dataSchema);
      const sinkConfigWithMapping = flowService.getSinkConfigWithMapping({
        sinkConfig,
        sinkMapping,
        isEditMode,
        connectionCategory,
      });

      return {
        sinkMapping,
        sinkConfig: sinkConfigWithMapping,
      };
    }

    return { sinkConfig };
  };

  const getDecodedSink = ({ sink, fields, credentials, sinkConfig }) => {
    const decodedSink = UIUtils.buildTemplatizedScriptConfigFromSource(sink, fields, credentials);

    return {
      scriptCredentialsData: decodedSink.scriptCredentialsData,
      sinkConfig: { ...sinkConfig, ...decodedSink.templatizedScriptConfig },
    };
  };

  return {
    getInitialSinkConfig,
    getDecodedSink,
  };
}
